module.exports = __webpack_public_path__ + "static/media/emoji_events.3559a02c.svg";